import { useRouter } from "next/router";
export default function Index({
  path,
  headingName,
  styles,
  themeColor = "white",   
  helpIcon = false,
  themeType="",
  popupClose = () => {},
}) {
  const router = useRouter();
  const handleBackClick = () => {
    if (path) {
      router.push(path);
    } else popupClose();
  };
  const handleHelpClick = () => {
    router.push("/faq");
  };

  return (
    <div
  className={`${styles.mobile_travel_search} ${themeType === "white" ? styles.mobile_travel_search_white : styles.mobile_travel_search_product} mainheader`}
>
 
  <div className={styles.leftSection}>
    <span
      className={styles.mobileBackArow}
      onClick={handleBackClick}
    >
      <img src="/images/right_arrow_bb.svg" alt="back" />
    </span>

    <div className={`${styles.travel_title_head} headertext`}>
      {headingName}
    </div>
  </div>


  {helpIcon && (
    <span className={styles.help_icon} onClick={handleHelpClick}>
      <img src="/images/support_bb_icon.svg" alt="help" />
    </span>
  )}
</div>

  );
}
